module.exports = __webpack_public_path__ + "img/megaphone.9228ac19.svg";